import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const RevertToDraftDialog = ({
  open,
  title = 'Regenerate SOW',
  description,
  note = 'This action will delete all existing documents.',
  loading = false,
  onCancel,
  onProceed,
}) => (
  <Dialog
    open={open}
    onClose={() => {
      if (!loading) {
        onCancel?.();
      }
    }}
    aria-labelledby='revert-dialog-title'
    maxWidth='sm'
    fullWidth
  >
    <DialogTitle id='revert-dialog-title' sx={{ fontSize: '1.25rem', fontWeight: 600 }}>
      {title}
    </DialogTitle>
    <DialogContent>
      {description && (
        <Typography variant='body2' fontSize='0.8125rem' marginBottom={1}>
          {description}
        </Typography>
      )}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <WarningAmberIcon sx={{ color: '#F59E0B', fontSize: '1.25rem', mt: 0.25 }} />
        <Typography variant='body2' sx={{ fontSize: '0.875rem', color: '#F59E0B' }}>
          <strong>Note:</strong> {note}
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button
        onClick={onProceed}
        variant='contained'
        color='primary'
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} /> : null}
      >
        Proceed
      </Button>
    </DialogActions>
  </Dialog>
);

export default RevertToDraftDialog;
